import './LoginScreen.scss';
import React, { useState } from 'react';
import axios from "axios";
import { useHistory } from "react-router-dom";
import CheaderHalf from '../../app-components/CheaderHalf';
import Alert from 'react-bootstrap/Alert'
import { GoogleLogin } from 'react-google-login';
import { globleAPI as Global } from '../../globals'


function LoginScreen() {

  const history = useHistory();
  const [password, setpassword] = useState('')
  const [passwordvalid, setpasswordvalid] = useState(false)
  const [status, setstatus] = useState()
  const [showAlert, setshowAlert] = useState(false)
  const [email, setemail] = useState('')
  const [emailN, setemailN] = useState(false)
  var mailformat: any = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;;

  const Login = () => {
    if (email === '' || password === '') {
      emailF()
      passwordFunc()
    } else {
      axios.post(Global.LOGIN, {
        email: email,
        password: password,
      })
        .then((response) => {
          if (response.data.status === 400) {
            setstatus(response.data.message)
            setshowAlert(true)
            setTimeout(() => {
              setshowAlert(false)
            }, 5000);
          } else {
            localStorage.setItem('userid', response.data.user.id);
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('first_name', response.data.user.first_name);
            localStorage.setItem('last_name', response.data.user.last_name);
            localStorage.setItem('imageProfile', response.data.user.profile_pic);
            localStorage.setItem('UserEmail', response.data.user.email);
            history.goBack()
          }
        }, (error) => {
          console.log('login api response error', error);
        });
    }
  }

  const emailF = () => {
    if (mailformat.test(email)) {
      console.log('email is match')
      setemailN(false)
    } else {
      setemailN(true)
    }
  }

  const passwordFunc = () => {
    if (password.length < 6) {
      setpasswordvalid(true)
    } else {
      setpasswordvalid(false)
    }
  }

  const responseGoogle = (data: any) => {
    saveGoogleLoginData(data)
    console.log(data.Os.ET)
    console.log(data.Os.GR)
    console.log(data.Os.zt)
  }

  const saveGoogleLoginData = (data: any) => {
    axios.post(Global.GOOGLE_LOGIN, {
      first_name: data.Os.ET,
      last_name: data.Os.GR,
      email: data.Os.zt,
    })
      .then((response) => {
        if (response.data.status == 400) {
          setstatus(response.data.message)
          setshowAlert(true)
          setTimeout(() => {
            setshowAlert(false)
          }, 5000);
        } else {
          localStorage.setItem('userid', response.data.user.id);
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('first_name', response.data.user.first_name);
          history.push('/')
        }
      }, (error) => {
        console.log('login api response error', error);
      });
  }

  const responseGoogleFail = (data: any) => {
    console.log('fail', data)
  }

  return (
    <div >
      <CheaderHalf />
      {showAlert == true ? (
        <div className='d-flex justify-content-center' >
          <Alert style={{ marginTop: '1%', position: 'absolute', width: 'auto', paddingLeft: '10%', paddingRight: '10%' }} variant="danger" show={showAlert}  >
            <Alert.Heading style={{ textAlign: 'center' }} ></Alert.Heading>
            <p>{status}</p>
          </Alert>
        </div>
      ) : null}
      <div style={{ height: '80vh', display: 'flex', justifyContent: 'center', flexDirection: 'column' }} >
        <div style={{ alignItems: 'center', display: 'flex', flexDirection: 'column' }} >
          <p className='  f-15  main-font' style={{ color: 'gray' }} >Remember everything Important</p>
          <div>
            <GoogleLogin
              clientId="937559180864-0arkpdc3mleqviaiiirnotau029j00mo.apps.googleusercontent.com"
              buttonText="Continue with google"
              onSuccess={responseGoogle}
              onFailure={responseGoogleFail}
            />
          </div>
          <div style={{ marginTop: '1%' }}>
            <label className='main-font'>──────── or ────────</label>
          </div>
        </ div>
        <form >
          <div style={{ alignItems: 'center', display: 'flex', flexDirection: 'column' }} >
            <div className='col-md-3 col-lg-3 col-8 d-flex cm-t-10 flex-column' >
              <input id="email" onBlur={() => emailF()} type="text" className="form-control" name="email" placeholder="Email" value={email} onChange={(text: any) => setemail(text.target.value)} />
              {emailN == true ? (<p className='label text-danger f-13 main-font' >Email is not valid</p>) : null}
            </div>
          </div>
          <div style={{ alignItems: 'center', display: 'flex', flexDirection: 'column' }} >
            <div className='col-md-3 col-lg-3 col-8  flex-column d-flex cm-t-10'  >
              <input onBlur={() => passwordFunc()} type="password" className="form-control" placeholder="Password" value={password} onChange={(text: any) => setpassword(text.target.value)} />
              {passwordvalid == true ? (<p className='label text-danger f-13 main-font' >Must be at least 6 characters</p>) : null}
            </div>
          </ div>
        </form>
        <div className='margintop' style={{ alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
          <div className='col-md-3 col-8 col-xl-3' >
            <div className='col-12' >
              <button type="button" style={{ width: '100%' }} onClick={() => Login()} className="btn btn-primary border-0"  >Log In</button>
            </div>
          </ div>
        </div>
        <div className='margintop' onClick={() => history.push('/SignUp')} >
          <p className='text-center f-15  main-font' style={{ color: 'gray' }} >Dont you have an account?</p>
          <label className='text-center primary-color f-15  main-font  justify-content-center d-flex  underline touchAble' >Create Account</label>
        </div>
      </div>
    </div>
  );
}

export default LoginScreen;
